(() => {
  const LB_MODAL_SELECTOR = '.lb-dealeasy-popup-wrapper, lb-gift-product-picker, [class*="lb-gpp"], [class*="lb-dealeasy"], [class*="lb-upsell"], [class*="lb-sell"], [class*="lb-popup-cont"], [class*="lb-popup-overlay"]';

  const insideGiftModal = (target) => {
    if (!target || !target.closest) return false;
    if (target.closest(LB_MODAL_SELECTOR)) return true;
    let node = target.nodeType === 1 ? target : target.parentElement;
    while (node) {
      if (node.tagName && node.tagName.indexOf('LB-') === 0) return true;
      node = node.parentElement;
    }
    return false;
  };

  const patch = (ctor) => {
    if (!ctor || ctor.prototype.__ibGiftPatched) return;
    const proto = ctor.prototype;
    const originalHide = proto.hideForOutsideClickTarget;
    const originalAllow = proto.allowOutsideClickForTarget;

    proto.hideForOutsideClickTarget = function (target) {
      if (insideGiftModal(target)) return false;
      return originalHide.call(this, target);
    };

    proto.allowOutsideClickForTarget = function (target) {
      if (insideGiftModal(target)) return true;
      return originalAllow.call(this, target);
    };

    proto.__ibGiftPatched = true;
  };

  const existing = window.customElements && window.customElements.get('cart-drawer');
  if (existing) {
    patch(existing);
  } else if (window.customElements) {
    window.customElements.whenDefined('cart-drawer').then(() => patch(window.customElements.get('cart-drawer')));
  }

  const lbModalVisible = () => {
    const els = document.querySelectorAll(LB_MODAL_SELECTOR);
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      const r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) continue;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      return true;
    }
    return false;
  };

  let trapPaused = false;

  const sync = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const wantPaused = drawer.open && lbModalVisible();
    if (wantPaused && !trapPaused) {
      try {
        const ft = drawer.focusTrap;
        if (ft && ft.pause) {
          ft.pause();
          trapPaused = true;
        }
      } catch (e) {}
    } else if (!wantPaused && trapPaused) {
      try {
        const ft = drawer.focusTrap;
        if (ft && ft.unpause) ft.unpause();
      } catch (e) {}
      trapPaused = false;
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length || m.removedNodes.length) {
        schedule();
        return;
      }
    }
  });

  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('toggle', schedule, true);
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
